// Hiển thị nội dung markdown của câu hỏi.
//
// Logic parse nằm hết ở markdown.ts (dùng `marked`). File này chỉ lo phần
// bọc thẻ + style, vì nội dung markdown sinh ra `<p>`/`<ul>` mà các class sẵn
// có (`.note`) là style cho MỘT đoạn, áp lên markup nhiều khối thì hỏng.
//
// `md` là class duy nhất, khai báo trong theme.css bằng @apply — không rải
// class Tailwind dài dòng ở JSX.

import { memo } from 'react'
import { mdToHtml, mdToHtmlInline } from '../markdown'

/** Nội dung markdown dài: tình huống, giải thích, điểm cần nhớ. */
export const Md = memo(function Md({ text, className = '' }: { text: string; className?: string }) {
  if (!text?.trim()) return null
  return (
    <div
      className={`md ${className}`.trim()}
      dangerouslySetInnerHTML={{ __html: mdToHtml(text) }}
    />
  )
})

/** Markdown trong một dòng: phương án trả lời. Không sinh `<p>` vì sẽ phá
 *  layout nút. */
export function MdInline({ text }: { text: string }) {
  if (!text?.trim()) return null
  return <span dangerouslySetInnerHTML={{ __html: mdToHtmlInline(text) }} />
}
